require('./bootstrap');
window.flatpickr = require('./plugins/flatpickr');
